"use strict";
/* eslint-disable no-underscore-dangle */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.StreamBlockDefinition = exports.StreamBlock = exports.StreamBlockValidationError = void 0;
var uuid_1 = require("uuid");
var BaseSequenceBlock_1 = require("./BaseSequenceBlock");
var text_1 = require("../../../utils/text");
/* global $ */
var StreamBlockValidationError = /** @class */ (function () {
    function StreamBlockValidationError(nonBlockErrors, blockErrors) {
        this.nonBlockErrors = nonBlockErrors;
        this.blockErrors = blockErrors;
    }
    return StreamBlockValidationError;
}());
exports.StreamBlockValidationError = StreamBlockValidationError;
var StreamChild = /** @class */ (function (_super) {
    __extends(StreamChild, _super);
    function StreamChild() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*
    wrapper for a block inside a StreamBlock, handling StreamBlock-specific metadata
    such as id
    */
    StreamChild.prototype.getState = function () {
        return {
            type: this.type,
            value: this.block.getState(),
            id: this.id,
        };
    };
    StreamChild.prototype.getValue = function () {
        return {
            type: this.type,
            value: this.block.getValue(),
            id: this.id,
        };
    };
    return StreamChild;
}(BaseSequenceBlock_1.BaseSequenceChild));
var StreamBlockMenu = /** @class */ (function (_super) {
    __extends(StreamBlockMenu, _super);
    function StreamBlockMenu(placeholder, opts) {
        var _this = _super.call(this, placeholder, opts) || this;
        _this.groupedChildBlockDefs = opts.groupedChildBlockDefs;
        var animate = opts.animate;
        var dom = $("\n      <div>\n        <button data-streamblock-menu-open type=\"button\" title=\"" + text_1.escapeHtml(opts.strings.ADD) + "\"\n            class=\"c-sf-add-button c-sf-add-button--visible\">\n          <i aria-hidden=\"true\">+</i>\n        </button>\n        <div data-streamblock-menu-outer>\n          <div data-streamblock-menu-inner class=\"c-sf-add-panel\"></div>\n        </div>\n      </div>\n    ");
        $(placeholder).replaceWith(dom);
        _this.element = dom.get(0);
        _this.addButton = dom.find('[data-streamblock-menu-open]');
        _this.addButton.click(function () {
            _this.toggle();
        });
        _this.outerContainer = dom.find('[data-streamblock-menu-outer]');
        _this.innerContainer = dom.find('[data-streamblock-menu-inner]');
        _this.hasRenderedMenu = false;
        _this.isOpen = false;
        _this.canAddBlock = true;
        _this.disabledBlockTypes = new Set();
        _this.close({ animate: false });
        if (animate) {
            dom.hide().slideDown();
        }
        return _this;
    }
    StreamBlockMenu.prototype.renderMenu = function () {
        var _this = this;
        if (this.hasRenderedMenu)
            return;
        this.hasRenderedMenu = true;
        this.groupedChildBlockDefs.forEach(function (_a) {
            var _b = __read(_a, 2), group = _b[0], blockDefs = _b[1];
            if (group) {
                var heading = $('<h4 class="c-sf-add-panel__group-title"></h4>').text(group);
                _this.innerContainer.append(heading);
            }
            var grid = $('<div class="c-sf-add-panel__grid"></div>');
            _this.innerContainer.append(grid);
            blockDefs.forEach(function (blockDef) {
                var button = $("\n          <button type=\"button\" class=\"c-sf-button action-add-block-" + text_1.escapeHtml(blockDef.name) + "\">\n            <svg class=\"icon icon-" + text_1.escapeHtml(blockDef.meta.icon) + " c-sf-button__icon\" aria-hidden=\"true\">\n              <use href=\"#icon-" + text_1.escapeHtml(blockDef.meta.icon) + "\"></use>\n            </svg>\n            " + text_1.escapeHtml(blockDef.meta.label) + "\n          </button>\n        ");
                grid.append(button);
                button.click(function () {
                    if (_this.onRequestInsert) {
                        _this.onRequestInsert(_this.index, { type: blockDef.name });
                    }
                    _this.close({ animate: true });
                });
            });
        });
        // Disable buttons for any disabled block types
        this.disabledBlockTypes.forEach(function (blockType) {
            $("button.action-add-block-" + text_1.escapeHtml(blockType), _this.innerContainer).attr('disabled', 'true');
        });
    };
    StreamBlockMenu.prototype.setNewBlockRestrictions = function (canAddBlock, disabledBlockTypes) {
        var _this = this;
        this.canAddBlock = canAddBlock;
        this.disabledBlockTypes = disabledBlockTypes;
        // Disable/enable menu open button
        if (this.canAddBlock) {
            this.addButton.removeAttr('disabled');
        }
        else {
            this.addButton.attr('disabled', 'true');
        }
        // Close menu if its open and we no longer can add blocks
        if (!canAddBlock && this.isOpen) {
            this.close({ animate: true });
        }
        // Disable/enable individual block type buttons
        $('button', this.innerContainer).removeAttr('disabled');
        disabledBlockTypes.forEach(function (blockType) {
            $("button.action-add-block-" + text_1.escapeHtml(blockType), _this.innerContainer).attr('disabled', 'true');
        });
    };
    StreamBlockMenu.prototype.toggle = function () {
        if (this.isOpen) {
            this.close({ animate: true });
        }
        else {
            this.open({ animate: true });
        }
    };
    StreamBlockMenu.prototype.open = function (opts) {
        if (!this.canAddBlock) {
            return;
        }
        this.renderMenu();
        if (opts && opts.animate) {
            this.outerContainer.slideDown();
        }
        else {
            this.outerContainer.show();
        }
        this.addButton.addClass('c-sf-add-button--close');
        this.outerContainer.attr('aria-hidden', 'false');
        this.isOpen = true;
    };
    StreamBlockMenu.prototype.close = function (opts) {
        if (opts && opts.animate) {
            this.outerContainer.slideUp();
        }
        else {
            this.outerContainer.hide();
        }
        this.addButton.removeClass('c-sf-add-button--close');
        this.outerContainer.attr('aria-hidden', 'true');
        this.isOpen = false;
    };
    return StreamBlockMenu;
}(BaseSequenceBlock_1.BaseInsertionControl));
var StreamBlock = /** @class */ (function (_super) {
    __extends(StreamBlock, _super);
    function StreamBlock(blockDef, placeholder, prefix, initialState, initialError) {
        var _this = this;
        _this.blockDef = blockDef;
        _this.type = blockDef.name;
        _this.prefix = prefix;
        var dom = $("\n      <div class=\"c-sf-container " + text_1.escapeHtml(_this.blockDef.meta.classname || '') + "\">\n        <input type=\"hidden\" name=\"" + text_1.escapeHtml(prefix) + "-count\" data-streamfield-stream-count value=\"0\">\n        <div data-streamfield-stream-container></div>\n      </div>\n    ");
        $(placeholder).replaceWith(dom);
        if (_this.blockDef.meta.helpText) {
            // help text is left unescaped as per Django conventions
            $("\n        <span>\n          <div class=\"help\">\n            " + _this.blockDef.meta.helpIcon + "\n            " + _this.blockDef.meta.helpText + "\n          </div>\n        </span>\n      ").insertBefore(dom);
        }
        // StreamChild objects for the current (non-deleted) child blocks
        _this.children = [];
        // Insertion control objects - there are one more of these than there are children.
        // The control at index n will insert a block at index n
        _this.inserters = [];
        // Incrementing counter used to generate block prefixes, also reflected in the
        // 'count' hidden input. This count includes deleted items
        _this.blockCounter = 0;
        _this.countInput = dom.find('[data-streamfield-stream-count]');
        // Parent element of insert control and block elements (potentially including deleted items,
        // which are left behind as hidden elements with a '-deleted' input so that the
        // server-side form handler knows to skip it)
        _this.sequenceContainer = dom.find('[data-streamfield-stream-container]');
        _this.setState(initialState || []);
        _this.container = dom;
        if (initialError) {
            _this.setError(initialError);
        }
        return _this;
    }
    /*
     * Called whenever a block is added or removed
     *
     * Updates the state of add / duplicate block buttons to prevent too many blocks being inserted.
     */
    StreamBlock.prototype.blockCountChanged = function () {
        _super.prototype.blockCountChanged.call(this);
        this.canAddBlock = true;
        if (typeof this.blockDef.meta.maxNum === 'number' && this.children.length >= this.blockDef.meta.maxNum) {
            this.canAddBlock = false;
        }
        // If we can add blocks, check if there are any block types that have count limits
        this.disabledBlockTypes = new Set();
        if (this.canAddBlock) {
            var _loop_1 = function (blockType) {
                if (this_1.blockDef.meta.blockCounts.hasOwnProperty(blockType)) {
                    var counts = this_1.blockDef.meta.blockCounts[blockType];
                    if (typeof counts.max_num === 'number') {
                        var currentBlockCount = this_1.children.filter(function (child) { return child.type === blockType; }).length;
                        if (currentBlockCount >= counts.max_num) {
                            this_1.disabledBlockTypes.add(blockType);
                        }
                    }
                }
            };
            var this_1 = this;
            // eslint-disable-next-line no-restricted-syntax
            for (var blockType in this.blockDef.meta.blockCounts) {
                _loop_1(blockType);
            }
        }
        for (var i = 0; i < this.children.length; i++) {
            var canDuplicate = this.canAddBlock && !this.disabledBlockTypes.has(this.children[i].type);
            if (canDuplicate) {
                this.children[i].enableDuplication();
            }
            else {
                this.children[i].disableDuplication();
            }
        }
        for (var i = 0; i < this.inserters.length; i++) {
            this.inserters[i].setNewBlockRestrictions(this.canAddBlock, this.disabledBlockTypes);
        }
    };
    StreamBlock.prototype._createChild = function (blockDef, placeholder, prefix, index, id, initialState, sequence, opts) {
        return new StreamChild(blockDef, placeholder, prefix, index, id, initialState, sequence, opts);
    };
    StreamBlock.prototype._createInsertionControl = function (placeholder, opts) {
        // eslint-disable-next-line no-param-reassign
        opts.groupedChildBlockDefs = this.blockDef.groupedChildBlockDefs;
        return new StreamBlockMenu(placeholder, opts);
    };
    StreamBlock.prototype.insert = function (_a, index, opts) {
        var type = _a.type, value = _a.value, id = _a.id;
        var childBlockDef = this.blockDef.childBlockDefsByName[type];
        return this._insert(childBlockDef, value, id, index, opts);
    };
    StreamBlock.prototype._getChildDataForInsertion = function (_a) {
        var type = _a.type;
        /* Called when an 'insert new block' action is triggered: given a dict of data from the insertion control,
        return the block definition and initial state to be used for the new block.
        For a StreamBlock, the dict of data consists of 'type' (the chosen block type name, as a string).
        */
        var blockDef = this.blockDef.childBlockDefsByName[type];
        var initialState = this.blockDef.initialChildStates[type];
        return [blockDef, initialState, uuid_1.v4()];
    };
    StreamBlock.prototype.duplicateBlock = function (index, opts) {
        var child = this.children[index];
        var childState = child.getState();
        var animate = opts && opts.animate;
        childState.id = null;
        this.insert(childState, index + 1, { animate: animate, collapsed: child.collapsed });
        // focus the newly added field if we can do so without obtrusive UI behaviour
        this.children[index + 1].focus({ soft: true });
    };
    StreamBlock.prototype.setState = function (values) {
        _super.prototype.setState.call(this, values);
        if (values.length === 0) {
            /* for an empty list, begin with the menu open */
            this.inserters[0].open({ animate: false });
        }
    };
    StreamBlock.prototype.setError = function (errorList) {
        if (errorList.length !== 1) {
            return;
        }
        var error = errorList[0];
        // Non block errors
        var container = this.container[0];
        container.querySelectorAll(':scope > .help-block.help-critical').forEach(function (element) { return element.remove(); });
        if (error.nonBlockErrors.length > 0) {
            // Add a help block for each error raised
            error.nonBlockErrors.forEach(function (nonBlockError) {
                var errorElement = document.createElement('p');
                errorElement.classList.add('help-block');
                errorElement.classList.add('help-critical');
                errorElement.innerHTML = text_1.escapeHtml(nonBlockError.messages[0]);
                container.insertBefore(errorElement, container.childNodes[0]);
            });
        }
        // Block errors
        // eslint-disable-next-line no-restricted-syntax
        for (var blockIndex in error.blockErrors) {
            if (error.blockErrors.hasOwnProperty(blockIndex)) {
                this.children[blockIndex].setError(error.blockErrors[blockIndex]);
            }
        }
    };
    return StreamBlock;
}(BaseSequenceBlock_1.BaseSequenceBlock));
exports.StreamBlock = StreamBlock;
var StreamBlockDefinition = /** @class */ (function () {
    function StreamBlockDefinition(name, groupedChildBlockDefs, initialChildStates, meta) {
        var _this = this;
        this.name = name;
        this.groupedChildBlockDefs = groupedChildBlockDefs;
        this.initialChildStates = initialChildStates;
        this.childBlockDefsByName = {};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.groupedChildBlockDefs.forEach(function (_a) {
            var _b = __read(_a, 2), group = _b[0], blockDefs = _b[1];
            blockDefs.forEach(function (blockDef) {
                _this.childBlockDefsByName[blockDef.name] = blockDef;
            });
        });
        this.meta = meta;
    }
    StreamBlockDefinition.prototype.render = function (placeholder, prefix, initialState, initialError) {
        return new StreamBlock(this, placeholder, prefix, initialState, initialError);
    };
    return StreamBlockDefinition;
}());
exports.StreamBlockDefinition = StreamBlockDefinition;
